import Calculation, { CalculationContext as cc } from './Calculation'
export const CalculationContext = cc
export default Calculation
